import { Link } from 'react-router-dom';
import { FooterExplore } from './FooterExplore';
import { Layout, EnvelopeSimple, MapPin, WhatsappLogo } from '@phosphor-icons/react';

export function Footer() {
  return (
    <footer className="bg-[#0A0A23] text-white" data-testid="footer">
      <FooterExplore />
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <Layout size={28} weight="bold" className="text-[#3B82F6]" />
              <span className="font-black text-xl tracking-tight" style={{ fontFamily: 'Outfit' }}>
                <span className="text-[#3B82F6]">Surveys</span>
                <span className="text-[#8B5CF6]">Maps</span>
              </span>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6">
              Specialized CAD drafting services exclusively for land surveyors and surveying firms across North America.
            </p>
            <div className="space-y-3 text-sm text-zinc-400">
              <div className="flex items-center gap-3">
                <EnvelopeSimple size={18} className="text-[#3B82F6]" />
                <a href="mailto:enquiries@surveysmaps.com" className="hover:text-white transition-colors">enquiries@surveysmaps.com</a>
              </div>
              <div className="flex items-center gap-3">
                <EnvelopeSimple size={18} className="text-[#3B82F6]" />
                <a href="mailto:surveysmaps@gmail.com" className="hover:text-white transition-colors">surveysmaps@gmail.com</a>
              </div>
              <div className="flex items-center gap-3">
                <WhatsappLogo size={18} weight="fill" className="text-[#25D366]" />
                <div className="flex items-center gap-2">
                  <span>India: +91 80836 91588</span>
                  <a href="https://wa.me/918083691588" target="_blank" rel="noopener noreferrer" className="text-[#25D366] hover:text-[#20bd5a]" title="Chat on WhatsApp">
                    <WhatsappLogo size={14} weight="fill" />
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <WhatsappLogo size={18} weight="fill" className="text-[#25D366]" />
                <div className="flex items-center gap-2">
                  <span>USA: +1 938 307 1829</span>
                  <a href="https://wa.me/19383071829" target="_blank" rel="noopener noreferrer" className="text-[#25D366] hover:text-[#20bd5a]" title="Chat on WhatsApp">
                    <WhatsappLogo size={14} weight="fill" />
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-[#3B82F6] mt-0.5 flex-shrink-0" />
                <span className="text-sm leading-relaxed">Sanskruti Apartment, Basement, 11th Ln, Laxmi Nagar, Jaysingpur, Maharashtra 416101</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-6" style={{ fontFamily: 'Outfit' }}>Services</h3>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li><Link to="/services/boundary" className="hover:text-white transition-colors">Boundary Surveys</Link></li>
              <li><Link to="/services/topographic" className="hover:text-white transition-colors">Topographic Surveys</Link></li>
              <li><Link to="/services/alta" className="hover:text-white transition-colors">ALTA/NSPS Surveys</Link></li>
              <li><Link to="/services/subdivision" className="hover:text-white transition-colors">Subdivision Plats</Link></li>
              <li><Link to="/services/construction" className="hover:text-white transition-colors">Construction Surveys</Link></li>
              <li><Link to="/services/asbuilt" className="hover:text-white transition-colors">As-Built Surveys</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-6" style={{ fontFamily: 'Outfit' }}>Quick Links</h3>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/get-started" className="hover:text-white transition-colors">Get Started</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/support" className="hover:text-white transition-colors">Customer Support</Link></li>
              <li><Link to="/service-areas" className="hover:text-white transition-colors">Service Areas (50 States)</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors" data-testid="footer-blog-link">Blog</Link></li>
              <li><Link to="/outsourcing-company-land-survey-cad-drafting" className="hover:text-white transition-colors" data-testid="footer-outsourcing-company-link">Survey Drafting Outsourcing Company</Link></li>
              <li><Link to="/cad-drafting-service-provider-usa-land-surveying" className="hover:text-white transition-colors" data-testid="footer-usa-provider-link">CAD Drafting Provider USA</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Software */}
          <div>
            <h3 className="font-semibold text-lg mb-6" style={{ fontFamily: 'Outfit' }}>Software We Use</h3>
            <div className="flex flex-wrap gap-2">
              {['AutoCAD', 'Civil 3D', 'Carlson', 'IntelliCAD', 'BricsCAD', 'ProgeCAD'].map((sw) => (
                <span key={sw} className="px-3 py-1 bg-[#0F0B2E] text-zinc-300 text-xs font-mono rounded">
                  {sw}
                </span>
              ))}
            </div>
            <p className="text-zinc-500 text-xs mt-3 leading-relaxed">
              We are familiar with AutoCAD LISP; All Custom programs have made Drafting Easier
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#1a1440] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-zinc-500">
            &copy; {new Date().getFullYear()} SurveysMaps.com. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-zinc-500">
            <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/security" className="hover:text-white transition-colors">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
